import { NgModule } from '@angular/core';
import { UploadPassportComponent } from './upload-passport.component';
import { SharedModule } from '../shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [UploadPassportComponent],
  imports: [SharedModule, MatFormFieldModule, MatIconModule, MatButtonModule],
  exports: [UploadPassportComponent],
})
export class UploadPassportModule {}
